import Quill from "quill";

const BaseImageFormat = Quill.import("formats/image");
const ALLOWED_ATTRS = ["alt", "height", "width", "style", "data-align", "class"];

class ImageFormat extends BaseImageFormat {
  static formats(domNode) {
    return ALLOWED_ATTRS.reduce((acc, attr) => {
      if (domNode.hasAttribute(attr)) acc[attr] = domNode.getAttribute(attr);
      return acc;
    }, {});
  }

  format(name, value) {
    if (ALLOWED_ATTRS.includes(name)) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }
}

Quill.register(ImageFormat, true);
